import React from "react";
import {
    Collapse,
    Radio,
} from "antd";

import { IUser } from "../../../../Models/Models";
import { ScoutFeature } from "../../../../Enums/ScoutFeature";
import { hasFeature } from "../../../../Actions/Actions";

/*
    Using this little config to have a single point of data
*/
const radioDefaultAppsConfig = [
    {
        value: "PRODUCT_SELECTION",
        text: "Product Selection Screen",
        style: {
            display: "block"
        },
        disabled: false
    },
    {
        value: "span",
        text: "or launch directly into one of the following applications",
        style: {
            display: "block",
            margin: "5px 0"
        }
    },
    {
        name: "Scout4",
        value: "SCOUT",
        text: "SCOUT",
        disabled: false
    },
    {
        name: "RetailMatchReports",
        value: "MATCH",
        text: "Match",
        disabled: false
    },
    {
        name: "GpsInsights",
        value: "MOBILYTICS",
        text: "Mobilytics",
        disabled: false
    },
    {
        name: "IQ",
        value: ScoutFeature.IQ,
        text: "IQ",
        disabled: false
    },
    {
        name: "Factor",
        value: ScoutFeature.Factor,
        text: "Factor",
        disabled: false
    },
    {
        text: "Brand",
        value: "BRAND",
        disabled: true
    },
    {
        text: "Healthcare",
        value: "HEALTHCARE",
        disabled: true
    },
    {
        text: "Explore",
        value: "EXPLORE",
        disabled: true
    }
];
// As explained above, using the config to generate a list of the values and validate the defaultLoginApp response from getUserPreferences
export const radioDefaultAppValues = radioDefaultAppsConfig.map((i) => i.value);

interface IDefaultLoginApp {
    user: IUser;
    defaultApp: string;
    defaultAppChange: (app: string) => void;
}

const DefaultLoginApp = (props: IDefaultLoginApp): JSX.Element => {
    // Generate components from radioDefaultAppsConfig
    const radioComps: JSX.Element[] = [];
    for (const [i, v] of radioDefaultAppsConfig.entries()) {
        // disabled check
        let featureDisabled = v.disabled;
        if (v.name) {
            featureDisabled = !(hasFeature(props.user, ScoutFeature[v.name]));
        }

        if (v.value !== "span") {
            radioComps.push((
                <Radio
                    key={i}
                    value={v.value}
                    style={v.style}
                    disabled={featureDisabled}>
                    {v.text}
                </Radio>
            ));
        } else {
            radioComps.push((
                <span
                    key={i}
                    style={v.style}>
                    {v.text}
                </span>
            ));
        }
    }

    return (
        <div className="option" style={{ borderBottom: "none" }}>
            <div className="header" style={{ borderBottom: "1px solid #d9d9d9" }}>
                Login Options
            </div>
            <Collapse bordered={false}>
                <Collapse.Panel header="Default Login Application" key="Default Login Application">
                    <Radio.Group
                        defaultValue={props.defaultApp}
                        value={props.defaultApp}
                        onChange={(e) =>
                            props.defaultAppChange(e.target.value)
                        }
                    >
                        {radioComps}
                    </Radio.Group>
                </Collapse.Panel>
            </Collapse>
        </div>
    );
};

export default DefaultLoginApp;
